import { createFileRoute } from '@tanstack/react-router'

import PenyuluhPusatPage from '@/components/pages/backoffice/_klb-penyuluh/_pusat/containers/PenyuluhProvinsiPage'

export const Route = createFileRoute('/_backoffice/klb-penyuluh/pusat/')({
  component: PenyuluhPusatPage
})
